export const getDeviceVideosList = (state) => state.devicesVideosReducer?.list
